import { render } from "./lookup-document.vue?vue&type=template&id=a346a508&scoped=true&ts=true"
import script from "./lookup-document.vue?vue&type=script&lang=ts"
export * from "./lookup-document.vue?vue&type=script&lang=ts"

import "./lookup-document.vue?vue&type=style&index=0&id=a346a508&scoped=true&lang=scss"

import exportComponent from "/Applications/MAMP/htdocs/wrf.com/wrf-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a346a508"]])

export default __exports__